import { render, staticRenderFns } from "./ImgPlaceholder.vue?vue&type=template&id=76ec0d92&"
import script from "./ImgPlaceholder.vue?vue&type=script&lang=js&"
export * from "./ImgPlaceholder.vue?vue&type=script&lang=js&"
import style0 from "./ImgPlaceholder.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports